import { render, staticRenderFns } from "./PubchemSections.vue?vue&type=template&id=17a63540"
import script from "./PubchemSections.vue?vue&type=script&setup=true&lang=js"
export * from "./PubchemSections.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PubchemSections.vue?vue&type=style&index=0&id=17a63540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports